import type { CSSProperties } from 'react';

/** Two fields side by side when there is room, stacked when there is not. */
export const TWO_COLUMN_GRID: CSSProperties = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(170px, 1fr))',
  gap: 12,
};
